<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='科秘书考评' url='/achievement/sectionsecretary/scorerecordlist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">年份：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.year" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">季度：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.quarter" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/achievement/sectionsecretary/score" buttonname="新增"></AddButton>
          <!-- <ImportButton url="/achievement/stu/import" buttonname="导入"></ImportButton> -->
        </div>
        <!--end: Search Form -->
        <!--begin: Datatable -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="ScoreYear" label="年份">
            </el-table-column>
            <el-table-column prop="ScoreQuarter" label="季度">
            </el-table-column>
            <el-table-column prop="SecretaryName" label="姓名">
            </el-table-column>
            <el-table-column prop="SecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="Score" label="得分">
            </el-table-column>
            <el-table-column prop="Money" label="奖金">
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="Info(scope.row)" type="text" size="medium">详细</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ScoreRecordList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          section: '',
          year: '',
          quarter: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          secretarysec: ''
        },
        tableData: null,
        yearOptions: [],
        quarterOptions: [{
          value: '1',
          label: '一季度'
        }, {
          value: '2',
          label: '二季度'
        }, {
          value: '3',
          label: '三季度'
        }, {
          value: '4',
          label: '四季度'
        }],
        searchUrl: this.$utils.Url.zpgl + '/api/APISecretaryScore/List',
        loading: true,
        managesecOptions: []
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      },
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'StuScoreEdit',
          params: {
            id: row.CPIID
          }
        })
      },
      Info: function(row) {
        this.$router.push({
          name: 'SectionSecretaryScoreRecord',
          params: {
            id: row.ID
          }
        })
      },
      LoadYear: function() {
        var now = new Date()
        var y = now.getFullYear()

        for (var i = 0; i <= 20; i++) {
          var year = y - i
          var args = {
            value: year,
            label: year
          }

          this.yearOptions.push(args)
        }
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.LoadYear()
      this.LoadManageSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style>
</style>
